import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

registerServiceWorker();

// ErrorBoundary sets this flag right before an auto-reload triggered by a
// stale chunk (see ErrorBoundary.tsx), to avoid looping if reloading didn't
// help. Clear it once the app has been up a while so a *future* deploy still
// gets its own auto-reload chance instead of going straight to the fallback.
window.setTimeout(() => {
  try {
    sessionStorage.removeItem('chunk-error-reload-attempted');
  } catch {
    // sessionStorage unavailable (private mode edge cases) — nothing to clear
  }
}, 10000);